module.exports = __webpack_public_path__ + "static/0-464678e291205c49a7279b28e5ffc2cf.png";